import HttpMethod from '../../services/httpMethods'
import axios, { AxiosResponse } from 'axios';
import { ApiResponse } from '../../services/types';
import { makeRequest } from 'src/services/restcall';



export async function postRegisterEmissionSourceTypeOrganizationAPI(value:Object): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.POST, '/api/emissionsource/emissiontypeorganization', value)
}
export async function deleteEmissionSourceByTypeOrganizationAPI(value:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.DELETE, '/api/emissionsource/emissiontypeorganization/'+value, {})
}
export async function getEmissionSourceByTypeOrganizationIdAPI(value:string): Promise<ApiResponse> {
    return await makeRequest(HttpMethod.GET, '/api/emissionsource/emissiontypeorganization/'+value, {})
}